<template>
  <div>
    <h1>{{ report.titulo }}</h1>
    <div v-html="formattedBody" class="html-content"></div>
    <a :href="report.url" target="_blank" class="link">Ir al enlace</a>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useToast } from "primevue/usetoast";

// #region Props, Emits
const props = defineProps({
  report: {
    type: Object,
    required: true,
  },
});
// #endregion

// #region  Params, Ref, Reactives, Computed
const toast = useToast();
const router = useRouter();
const formattedBody = ref(null);
// #endregion

// #region Functions
onMounted(() => {
  if (!props.report.tieneLandingPage) {
    toast.add({
      severity: "info",
      summary: "Informe sin landing page",
      detail: `El informe no tiene landing page.`,
      life: 3000,
    });

    router.push({
      name: "Public reports",
    });
  } else {
    const piePagina = props.report.piePagina;

    // replace the sintaxis [url] inside the landingPage with the real url
    formattedBody.value = piePagina.replace(
      "[url]",
      `<a href='${props.report.url}' target='_blank'>${props.report.url}</a>`
    );
  }
});
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
// #endregion
</script>

<style lang="scss" scoped>
@import "@/styles/_vars.scss";

.html-content {
  word-break: break-all;
}

.link {
  color: $primary;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
